'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaultExport = new String('@media (min-width:768px){.no-scroll{overflow:hidden;}}');

_defaultExport.__hash = '1615734277';
_defaultExport.__scoped = '@media (min-width:768px){.no-scroll.jsx-3195350564{overflow:hidden;}}';
_defaultExport.__scopedHash = '3195350564';
exports.default = _defaultExport;